import script from "./WebsiteChannel.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsiteChannel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NeueButton from "@/components/neue/NeueButton.vue";
import NeueToggle from "@/components/neue/NeueToggle.vue";
import SettingCard from "@/components/settings/SettingCard.vue";
script.components = Object.assign({}, { NeueButton, NeueToggle, SettingCard }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NeueButton, NeueToggle, SettingCard }, script.__o.components);}